import { useState } from "react";
import { INIT_SPACE_FORM_ERRORS, INIT_SPACE_FORM, FORM_FIELD_KEYS } from "../constants";
import { errorFree } from "utils/validations";

const useSpaceForm = ({
	spaceSelected
}) => {
    const [form, setForm] = useState({ ...INIT_SPACE_FORM });
    const [errors, setErrors] = useState({ ...INIT_SPACE_FORM_ERRORS });
    function updateForm(values) {
        setForm(prev => ({
            ...prev,
            ...values
        }))
    }
	function setField(field, value) {
        setForm(prev => ({
            ...prev,
            [field]: typeof value === "function" ? value(prev[field]) : value
        }));
    }
    function setError(field, value) {
        setErrors(prev => ({
            ...prev,
            [field]: typeof value === "function" ? value(prev[field]) : value
        }));
    }
	function areThereChanges() {
        if (!spaceSelected.value) return true;
        const {
            campusId, spaceTypeId, name,
            availableActivityIds, minCapacity,
            maxCapacity, address,
            reference, details
        } = spaceSelected.value;
        return (
            form.campusId !== campusId
            || form.spaceTypeId !== spaceTypeId
            || form.name !== name
            || form.availableActivityIds.length !== availableActivityIds.length
            || !form.availableActivityIds.every(id => availableActivityIds.includes(id))
            || form.minCapacity !== minCapacity
            || form.maxCapacity !== maxCapacity
            || form.address !== address
            || form.reference !== reference
            || form.details !== details
        );
    }
	function areThereErrors() {
        return !errorFree(errors);
    }
	function isCompletedForm() {
        const {
            campusId, spaceTypeId, name,
            availableActivityIds, minCapacity,
            maxCapacity, address, spaceOutOfCampus,
            reference
        } = form;
        return Boolean(
            campusId !== 0 &&
            spaceTypeId !== 0 &&
            name &&
            availableActivityIds.length > 0 &&
            Number(minCapacity) > 0 &&
            Number(maxCapacity) > 0 &&
            (!spaceOutOfCampus || address) &&
            reference
        );
    }
    function setCampus(value) {
        if (spaceSelected.isEmpty()) 
            setField(FORM_FIELD_KEYS.CAMPUS_ID, value);
    }
    function setSpaceType(value) {
        if (spaceSelected.isEmpty()) 
            setField(FORM_FIELD_KEYS.SPACE_TYPE_ID, value);
    }
    function setName(value) {
        setField(FORM_FIELD_KEYS.NAME, value);
    }
    function setMinCapacity(value) {
        setField(FORM_FIELD_KEYS.MIN_CAPACITY, value);
    }
    function setMaxCapacity(value) {
        setField(FORM_FIELD_KEYS.MAX_CAPACITY, value);
    }
    function setAddress(value) {
        setField(FORM_FIELD_KEYS.ADDRESS, value);
    }
    function setReference(value) {
        setField(FORM_FIELD_KEYS.REFERENCE, value);
    }
    function setDetails(value) {
        setField(FORM_FIELD_KEYS.DETAILS, value);
    }
    function setAvailableActivities(value) {
        setField(FORM_FIELD_KEYS.AVAILABLE_ACTIVITY_IDS, value);
    }    
	function toggleSpaceOutOfCampus() {
        setField(FORM_FIELD_KEYS.SPACE_OUT_OF_CAMPUS, prev => !prev);
    }
	return {
		form: {
			value: form,
			change: setField,
            setCampus, setSpaceType, setName,
            setMinCapacity, setMaxCapacity,
            setAddress, setReference, setDetails, 
            setAvailableActivities, 
            update: updateForm,
			areThereChanges,
			isCompleted: isCompletedForm,
			toggleSpaceOutOfCampus,
		},
		errors: {
            value: errors,
            change: setError,
            areThere: areThereErrors
        }
	};
}	
	
export default useSpaceForm;